import {
  Typography,
  CircularProgress,
  Box,
  LinearProgress,
} from "@material-ui/core";

const LoadingProgressComponent = ({ value }: { value: number }) => {
  return (
    <Box display="inline-block" justifyItems="center">
      <Box position="relative" mb={3}>
        <CircularProgress
          variant="determinate"
          size={100}
          value={Math.ceil(value)}
          style={{ color: "#FFFFFF" }}
        />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="body1">{`${Math.ceil(value)}%`}</Typography>
        </Box>
      </Box>

      <Box>
        <Box width="100%">
          <LinearProgress style={{ backgroundColor: "#FFFFFF" }} />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2">
            Loading route lines and timings...
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingProgressComponent;
